/**
 * Instapaper Premium pricing, honoring the student discount.
 *
 * Mirrors the legacy `_premium_form.html`: students pay $2.99/mo and $29.99/yr,
 * everyone else pays $5.99/mo and $59.99/yr. Shared by the Settings > Premium
 * page and the premium upsell modal so both show consistent, discount-aware
 * prices.
 */
export interface PremiumPricing {
  /** Formatted monthly price, e.g. "$5.99". */
  monthly: string;
  /** Formatted yearly price, e.g. "$59.99". */
  yearly: string;
  /** Formatted yearly savings vs. paying monthly, e.g. "$12". */
  yearlySavings: string;
}

export function getPremiumPricing(hasStudentDiscount = false): PremiumPricing {
  const monthly = hasStudentDiscount ? 2.99 : 5.99;
  const yearly = hasStudentDiscount ? 29.99 : 59.99;
  const savings = Math.round(monthly * 12 - yearly);

  return {
    monthly: `$${monthly.toFixed(2)}`,
    yearly: `$${yearly.toFixed(2)}`,
    yearlySavings: `$${savings}`,
  };
}
